<template>
  <div class="main">
    <div class="main-top">
      <div class="main-top-left">
        <el-image v-if="pageDataList.headImg" style="width: 56px; height: 56px; border-radius: 50%; border: 2px solid rgba(255,255,255,1)" :src="pageDataList.headImg.smallHeadImg" @click="showImg(pageDataList.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        <div style="margin-left: 16px; color: #ffffff; line-height: 1.6">
          <p>进入情况：{{pageDataList.enterType == -1?'未进入':pageDataList.enterType == 0?'免费进入':pageDataList.enterType == 1?'邀请码进入':pageDataList.enterType == 2?'认证费用':pageDataList.enterType == 3?'保证金进入+认证费用':pageDataList.enterType == 4?'保证金+邀请码':pageDataList.enterType == 5?'直接进入':pageDataList.enterType == 6?'芝麻认证进入':pageDataList.enterType == 7?'身份证直接进入':pageDataList.enterType == 8?'H5直接进入':pageDataList.enterType == 9?'百度认证直接进入':'--'}}</p>
          <p>进入包名：{{pageDataList.enterPackageName}}</p>
          <p>进入渠道：{{pageDataList.channelShowInfo}}</p>
        </div>
      </div>
      <div class="wechat" v-if="pageDataList.wechatImg">
<!--        <span>微信二维码</span>-->
        <GetPlain class="wechat-img" :url="pageDataList.wechatImg" :uid="pageDataList.uid" :type="11" :subType="0"/>
      </div>
    </div>
    <el-descriptions style="margin-top: 24px;" title="人物信息" :column="2" size="small" border>
      <el-descriptions-item label="昵称" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.nickName }}<span style="color: #ff0000; margin-left: 8px;">{{pageDataList.svipState > 0 ? "SVIP" :pageDataList.vipState > 0 ? "VIP" : ""}}</span>
      </el-descriptions-item>
      <el-descriptions-item label="身份证实名" label-class-name="my-label" class-name="my-item">
<!--        <p v-if="pageDataList.identityAuth" class="cursor" @click="showIdentityImg">-->
        <p v-if="pageDataList.identityAuth">
          <span v-if="pageDataList.identityAuth.identityState == 2 || pageDataList.identityAuth.zhimaState == 1 || pageDataList.identityAuth.baiduState == 1">
          {{ pageDataList.identityAuth.identityState == 2?pageDataList.identityAuth.identityName:pageDataList.identityAuth.zhimaState == 1?pageDataList.identityAuth.zhimaCertName + '（芝麻）':pageDataList.identityAuth.baiduState == 1?pageDataList.identityAuth.baiduCertName + '（百度）':'' }}
          </span>
          <span v-else>
            {{ pageDataList.identityAuth.identityName }}
          </span>
          <span class="cursor" @click="showIdentityImg" style="color: #409eff; margin-left: 8px;">查看</span>
        </p>
      </el-descriptions-item>
      <el-descriptions-item label="性别" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.sex==1?'男':pageDataList.sex==2?'女':''}}
      </el-descriptions-item>
      <el-descriptions-item label="身份证号码" label-class-name="my-label" class-name="my-item">
<!--        {{ pageDataList.identityAuth?pageDataList.identityAuth.identityCode:''  }}-->
        <div v-if="pageDataList.identityAuth">
          <div v-if="pageDataList.identityAuth.identityState == 2 || pageDataList.identityAuth.zhimaState == 1 || pageDataList.identityAuth.baiduState == 1">
            <p v-if="pageDataList.identityAuth.identityState == 2"><get-plain-dialog title="" :code="pageDataList.identityAuth.identityCode" :uid="pageDataList.uid" :type="10" :subType="1"/></p>
            <p v-else-if="pageDataList.identityAuth.zhimaState == 1"><get-plain-dialog title="" :code="pageDataList.identityAuth.zhimaCertCode" :uid="pageDataList.uid" :type="10" :subType="2"/></p>
            <p v-else-if="pageDataList.identityAuth.baiduState == 1"><get-plain-dialog title="" :code="pageDataList.identityAuth.baiduCertCode" :uid="pageDataList.uid" :type="10" :subType="3"/></p>
          </div>
          <div v-else>
            <get-plain-dialog title="" :code="pageDataList.identityAuth.identityCode" :uid="pageDataList.uid" :type="10" :subType="1"/>
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="生日" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.sysBirthday }}
      </el-descriptions-item>
      <el-descriptions-item label="身份证类型" label-class-name="my-label" class-name="my-item">
        <div v-if="pageDataList.identityAuth">
          <p>{{ pageDataList.identityAuth.type == 1?'身份证':pageDataList.identityAuth.type == 2?'非身份证':pageDataList.identityAuth.type == 3?'其他':''}}</p>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="年龄" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.age }}岁
      </el-descriptions-item>
      <el-descriptions-item label="籍贯地址" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.nativePlace }}
      </el-descriptions-item>
      <el-descriptions-item label="身高" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.height }}cm
      </el-descriptions-item>
      <el-descriptions-item label="ID号码" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.uid}}
      </el-descriptions-item>
      <el-descriptions-item label="学历" label-class-name="my-label" class-name="my-item">
        {{pageDataList.education == 1 ? "初中" : pageDataList.education == 2 ? "中专/职高/技校" : pageDataList.education == 3 ? "高中" : pageDataList.education == 4 ? "大专" : pageDataList.education == 5 ? "本科" : pageDataList.education == 6 ? "硕士" : pageDataList.education == 7 ? "博士" : pageDataList.education == 8 ? "博士后" : "--"}}
      </el-descriptions-item>
      <el-descriptions-item label="手机号码" label-class-name="my-label" class-name="my-item">
<!--        {{ pageDataList.phone}}-->
        <get-plain-dialog title="" :code="pageDataList.phone" :uid="pageDataList.uid" :type="9" :subType="0"/>
      </el-descriptions-item>
      <el-descriptions-item label="家乡" label-class-name="my-label" class-name="my-item">{{ pageDataList.homeCity }}</el-descriptions-item>
      <el-descriptions-item label="年收入" label-class-name="my-label" class-name="my-item" v-if="pageDataList.annualSalary > 0">
        {{pageDataList.annualSalaryName}}
      </el-descriptions-item>
      <el-descriptions-item label="月收入" label-class-name="my-label" class-name="my-item">
        {{pageDataList.salaryMin == -1 ? '不限' : pageDataList.salaryMin}}-{{pageDataList.salaryMax == -1 ? '不限' : pageDataList.salaryMax + 'k'}}
      </el-descriptions-item>
      <el-descriptions-item label="现居城市" label-class-name="my-label" class-name="my-item">{{ pageDataList.city }}</el-descriptions-item>
      <el-descriptions-item label="婚姻" label-class-name="my-label" class-name="my-item">
        {{pageDataList.marryState == 1? '未婚' : pageDataList.marryState == 2? '离异' : pageDataList.marryState == 2? '丧偶' : ''}}
      </el-descriptions-item>
      <el-descriptions-item label="所在专区" label-class-name="my-label" class-name="my-item">
        <div v-for="item in pageDataList.specialsUserList" :key="item.id" style="float: left; margin-right: 24px;">
          {{item.name}} <span style="color:blue;">{{item.isShow==1?'外展':''}}</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="期望结婚时间" label-class-name="my-label" class-name="my-item">
        {{pageDataList.marryTime==1 ? "半年内" : pageDataList.marryTime - 1 + "年内"}}
      </el-descriptions-item>

      <el-descriptions-item label="自我介绍" label-class-name="my-label" class-name="my-item" span="2">{{ pageDataList.pdesc }}</el-descriptions-item>
      <el-descriptions-item label="信息标签" label-class-name="my-label" class-name="my-item" span="2">
        <div v-if="pageDataList.userTagList">
          <div class="tag-list" style="margin-top: 4px;">
            <label class="tag-title">关于我：</label>
            <div style="flex: 1"><el-tag class="tap-item" v-for="(item,index) in pageDataList.userTagListMe" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag></div>
          </div>
          <div class="tag-list">
            <label class="tag-title">理想的Ta：</label>
            <div style="flex: 1"><el-tag class="tap-item" v-for="(item,index) in pageDataList.userTagListTa" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag></div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="display: flex; justify-content: space-between;">
      <el-descriptions style="margin-top: 24px;width: 49%" title="认证情况" :column="1" size="small" border>
        <el-descriptions-item label="职业认证" label-class-name="my-label" class-name="my-item">
          <p v-if="pageDataList.authJob">{{pageDataList.authJob.jobState == 3?'认证失败':pageDataList.authJob.jobState == 2?'已认证':pageDataList.authJob.jobState == 1?'待认证':'--'}}</p>
          <p v-else>未认证</p>
        </el-descriptions-item>
        <el-descriptions-item label="学历认证" label-class-name="my-label" class-name="my-item">
          <p v-if="pageDataList.authEdu">{{pageDataList.authEdu.eduState == 3?'认证失败':pageDataList.authEdu.eduState == 2?'已认证':pageDataList.authEdu.eduState == 1?'待认证':'--'}}</p>
          <p v-else>未认证</p>
        </el-descriptions-item>
        <el-descriptions-item label="车辆认证" label-class-name="my-label" class-name="my-item">
          <p v-if="pageDataList.authCar">{{pageDataList.authCar.carState == 3?'认证失败':pageDataList.authCar.carState == 2?'已认证':pageDataList.authCar.carState == 1?'待认证':'--'}}</p>
          <p v-else>未认证</p>
        </el-descriptions-item>
        <el-descriptions-item label="房产认证" label-class-name="my-label" class-name="my-item">
          <p v-if="pageDataList.authHouse">{{pageDataList.authHouse.houseState == 3?'认证失败':pageDataList.authHouse.houseState == 2?'已认证':pageDataList.authHouse.houseState == 1?'待认证':'--'}}</p>
          <p v-else>未认证</p>
        </el-descriptions-item>
        <el-descriptions-item label="视频认证" label-class-name="my-label" class-name="my-item">
          <p v-if="pageDataList.authVideo">{{pageDataList.authVideo.state == 3?'认证失败':pageDataList.authVideo.state == 2?'已认证':pageDataList.authVideo.state == 1?'待认证':'--'}}</p>
          <p v-else>未认证</p>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions style="margin-top: 24px;width: 50%" title="审核展示" :column="1" size="small" border>
        <el-descriptions-item label="信息审核是否通过" label-class-name="my-label" class-name="my-item">
          {{pageDataList.resumeState==0?'未提交':pageDataList.resumeState==1?"待审核":pageDataList.resumeState==2?"已通过":pageDataList.resumeState==3?"不通过":""}}
        </el-descriptions-item>
        <el-descriptions-item label="沟通用语是否通过" label-class-name="my-label" class-name="my-item">
          {{pageDataList.isGreetingPass?'是':'否'}}
        </el-descriptions-item>
        <el-descriptions-item label="是否被展示" label-class-name="my-label" class-name="my-item">
          {{pageDataList.isDel==1?'否':'是'}}
        </el-descriptions-item>
        <el-descriptions-item label="是否为置顶用户" label-class-name="my-label" class-name="my-item">
          {{pageDataList.isUserTop?'是':'否'}}
        </el-descriptions-item>
        <el-descriptions-item label="是否异常" label-class-name="my-label" class-name="my-item">
          {{pageDataList.isAbnormal?'是':'否'}}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-descriptions style="margin-top: 24px;" title="数据统计" :column="1" size="small" border>
      <el-descriptions-item label="动态发布次数" label-class-name="my-label" class-name="my-item-1">
        {{pageDataList.zonePushNum}}
      </el-descriptions-item>
      <el-descriptions-item label="牵线服务使用次数" label-class-name="my-label" class-name="my-item-1">
        邀约人数：{{pageDataList.matcherUsedNum}}<span style="margin-left: 32px;">被邀约次数：{{pageDataList.matcherInvitedNum}}</span>
      </el-descriptions-item>
      <el-descriptions-item label="举报次数" label-class-name="my-label" class-name="my-item-1">
        {{pageDataList.reportNum}}
      </el-descriptions-item>
      <el-descriptions-item label="被举报次数" label-class-name="my-label" class-name="my-item-1">
        {{pageDataList.toReportNum}}
      </el-descriptions-item>
      <el-descriptions-item label="微信下载次数" label-class-name="my-label" class-name="my-item-1">
        {{pageDataList.wechatDownloadNum}}
      </el-descriptions-item>
      <el-descriptions-item label="相册照片数量" label-class-name="my-label" class-name="my-item-1">
        <p v-if="pageDataList.photoList" style="color: #409eff; cursor: pointer;" @click="showPhotoImg(pageDataList.photoList)">{{pageDataList.photoList.length}}</p>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { getUserDetailInfo, getSysConfig } from "@/api/url";
import { getFormData } from "@/api/api";
import ImgViewer from "@/assets/js/imageViewer";
import GetPlainDialog from "@/components/resume/GetPlainDialog";
import GetPlain from "@/components/resume/GetPlain";
import Dialog from "@/assets/js/dialog";
import IdentityExamineImg from "@/views/review/components/identity/IdentityExamineImg";
export default {
  name: "userInfoDialog",
  components: { GetPlainDialog, GetPlain },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      pageDataList: {},
      smallHeadImg: '',
      annualSalaryList: []
    }
  },
  methods: {

    getUserDetailInfo() {
      let param={}
      param['id'] = this.userId
      getFormData(getUserDetailInfo, param).then((data)=>{
        let { code, msg } = data
        if(code == 200) {
          this.pageDataList = data['data'];
          this.smallHeadImg = data['data'].headImg.smallHeadImg;
          if(this.pageDataList.userTagList) {
            this.pageDataList.userTagListMe = []
            this.pageDataList.userTagListTa = []
            for(let i=0; i<this.pageDataList.userTagList.length; i++) {
              if(this.pageDataList.userTagList[i].type == 1) {
                this.pageDataList.userTagListMe.push(this.pageDataList.userTagList[i])
              }else {
                this.pageDataList.userTagListTa.push(this.pageDataList.userTagList[i])
              }
            }
          }
          this.pageDataList.annualSalaryName = ''
          this.annualSalaryList.map(item => {
            if(item.type == this.pageDataList.annualSalary) {
              this.pageDataList.annualSalaryName = item.name
            }
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    showPhotoImg(row) {
      let imgList = []
      row.map(item => {
        imgList.push(item.img)
      })
      ImgViewer.open({
        imgList
      })
    },

    showIdentityImg() {
      if(this.pageDataList.identityAuth.imgZ == '' && this.pageDataList.identityAuth.imgF == ''){
        return;
      }
      Dialog.open({
        title: '身份证图片',
        component: IdentityExamineImg,
        data: {
          identityForm: this.pageDataList.identityAuth,
          uid: this.pageDataList.uid,
          width: '1300px'
        },
        confirm: (result) => {

        }
      })
    },

    getSysConfig() {
      getFormData(getSysConfig).then(data => {
        this.annualSalaryList = data.data.annualSalaryList
        this.getUserDetailInfo();
      })
    }

  },
  mounted() {
    this.getSysConfig()
  }
}
</script>

<style scoped>
.main {
  padding: 0 24px 28px;
}
.main-top {
  display: flex;
  justify-content: space-between;
  background-color: #42b983;
  padding: 24px;
  position: relative;
}
.main-top-left {
  display: flex;
  align-items: center
}
.wechat {
  position: absolute;
  right: 24px;
  bottom: -24px;
  text-align: center;
  color: #ffffff;
  /*background-color: #ffffff;*/
  /*padding: 8px;*/
  border-radius: 4px;
  /*border: 1px solid #ededed;*/
  /*box-shadow:  0 4px 8px 4px rgba(0, 0, 0, 0.03);*/
}
.wechat-img {
  border: 3px solid #ffffff;
  margin-top: 8px;
  background-color: #ffffff;
}
.tag-title {
  font-size: 12px;
  margin-bottom: 4px;
  width: 72px;
}
.tap-item {
  margin: 0 4px 4px 0;
  /*display: inline-block;*/
}
.tag-list {
  display: flex;
}
</style>
